import React from 'react';
import util from 'Utils/commonUtil';
// Components
import Anchor from 'Components/common/Anchor';
import {loadLanguage} from 'Utils/jwtUtil';
import BasicButton from 'Components/common/BasicButton';

// Actions
import {T} from 'Actions/translate';

class TaskManagementItem extends React.Component {
    state = {
        expandedId: null,
    };

    showInstitutionHandle = (e, index) => {
        e.stopPropagation();
        this.setState((prevState) => {
            return {
                expandedId: prevState.expandedId ? null : index,
            };
        });
    };

    stopBubble = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    getMandatoryTaskCount = (item) => {
        let mandatoryTaskCount = item.requiredCount;
        return mandatoryTaskCount;
    };

    getNonMandatoryTaskCount = (item) => {
        const nonMandatoryTaskCount = item.optionalCount;
        return nonMandatoryTaskCount;
    };

    render() {
        const {item, tabFlag} = this.props;
        let lang = loadLanguage();

        return (
            <Anchor>
                {item.progressCount !== 0 ? (
                    <h6 className="my-task-item-title">
                        <div className="ready-payment-style">
                            {T('task_management_progress_task_label')}
                        </div>
                    </h6>
                ) : null}

                <div className="task-no">{item.taskNo}</div>

                <div className="header-title row">
                    <div className="task-content-wrapper">
                        <div className="task-title-wrapper">
                            {item.taskName}
                            {item.reward ? (
                                <div className="show-score">{item.reward}</div>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="task-desc">{item.description}</div>

                <div className="task-wrapper">
                    <div className="task-content">
                        {tabFlag === 1 && item.requiredCount !== 0 ? (
                            <p className="mandatory-task text-ellipsis row">
                                <div>
                                    {T('task_management_mandatory_task', [
                                        item.requiredCount,
                                    ])}
                                </div>
                            </p>
                        ) : null}
                        {tabFlag === 1 && item.optionalCount !== 0 ? (
                            <p className="non-mandatory-task text-ellipsis row">
                                <div>
                                    {T('task_management_non_mandatory_task', [
                                        item.optionalCount,
                                    ])}
                                </div>
                            </p>
                        ) : null}

                        {item.completedCount > 0 ? (
                            <p className="text-ellipsis row">
                                <div
                                    className={
                                        item.taskStatus === 'progress'
                                            ? 'task-status progress-task'
                                            : 'task-status'
                                    }>
                                    {T('task_management_completed_task', [
                                        item.completedCount,
                                    ])}
                                </div>
                            </p>
                        ) : null}
                        {item.submittedCount > 0 ? (
                            <p className="text-ellipsis row">
                                <div
                                    className={
                                        item.taskStatus === 'progress'
                                            ? 'task-status progress-task'
                                            : 'task-status'
                                    }>
                                    {T('task_management_submitted_task', [
                                        item.submittedCount,
                                    ])}
                                </div>
                            </p>
                        ) : null}
                        {item.progressCount > 0 ? (
                            <p className="text-ellipsis row">
                                <div
                                    className={
                                        item.taskStatus === 'progress'
                                            ? 'task-status progress-task'
                                            : 'task-status'
                                    }>
                                    {T('task_management_progress_task', [
                                        item.progressCount,
                                    ])}
                                </div>
                            </p>
                        ) : null}
                    </div>
                </div>

                <div
                    className={util.getClassName({
                        tag: true,
                        'is-tag': true && lang !== 'EN',
                    })}
                    data-content={item.tag}></div>

                <div className="task-button-wrapper">
                    <BasicButton
                        type="primary"
                        className="basic-style view-task-btn"
                        onClickOfSingleTap={this.props.goToCustomerAssignment}
                        isStopPropagation={true}>
                        {T('task_details_view_task')}
                    </BasicButton>
                </div>
            </Anchor>
        );
    }
}

export default TaskManagementItem;
